export interface Fabric {
  _id?: string;
  id?: string;
  name: string;
  fabricClass: string; // woven/knitted - Dokuma/Örme
  type: string;
  yarnNumber: string; // İplik numarası
  composition: string; // İçerik bilgisi
  dyeingType: string; // yarn_dyed/piece_dyed/printed
  density: { // Sıklık bilgisi
    warp: string; // Çözgü
    weft: string; // Atkı
  }; 
  weight: number; // Gramaj (gr/m2)
  width: number; // Kumaş eni (cm)
  notes: string; // Not alanı
  description: string; // Açıklama
  
  // Ticari bilgiler
  price: number; // Fiyat
  currency?: string; // Döviz (TRY, USD, EUR)
  priceUnit?: string; // Fiyat birimi (meter, gram)
  minOrderQuantity: number; // Minimum sipariş miktarı
  leadTime: string; // Teslimat süresi
  supplier: string; // Tedarikçi
  
  // Teknik özellikler
  stretch: string; // Elastikiyet 
  
  // Liste alanları
  colors: string[]; // Renk seçenekleri
  properties: string[]; // Özellikler
  useCases: string[]; // Kullanım alanları

  // Görsel alanları
  imageUrl: string;
  swatch: string;
  
  // Sistem alanları
  createdAt: string;
  updatedAt: string;
  __v?: number;
}

// Veritabanında kullanılacak değerler (İngilizce)
export const fabricClassValues = [
  "woven",
  "knitted"
];

// Kullanıcı arayüzünde gösterilecek değerler (Türkçe)
export const fabricClasses = [
  "Dokuma",
  "Örme"
];

// İngilizce-Türkçe eşleşme için yardımcı fonksiyonlar
export const fabricClassValueToLabel = (value: string): string => {
  const index = fabricClassValues.indexOf(value);
  return index >= 0 ? fabricClasses[index] : value;
};

export const fabricClassLabelToValue = (label: string): string => {
  const index = fabricClasses.indexOf(label);
  return index >= 0 ? fabricClassValues[index] : label;
};

// Diğer enum değerleri için de benzer yaklaşımı uygulayalım

// Fabric Types - Veritabanı değerleri
export const fabricTypeValues = [
  "cotton", "linen", "silk", "wool", "denim", "velvet", 
  "polyester", "nylon", "acrylic", "viscose", "satin", 
  "chiffon", "taffeta", "tweed", "poplin", "oxford", "jersey", 
  "gabardine", "crepe", "stretch", "fleece", "knit", "woven"
];

// Fabric Types - Arayüz etiketleri
export const fabricTypes = [
  "Pamuklu", "Keten", "İpek", "Yün", "Denim", "Kadife", 
  "Polyester", "Naylon", "Akrilik", "Viskon", "Saten", 
  "Şifon", "Tafta", "Tweed", "Poplin", "Oxford", "Jersey", 
  "Gabardin", "Krep", "Streç", "Polar", "Triko", "Dokuma"
];

export const fabricTypeValueToLabel = (value: string): string => {
  const index = fabricTypeValues.indexOf(value);
  return index >= 0 ? fabricTypes[index] : value;
};

export const fabricTypeLabelToValue = (label: string): string => {
  const index = fabricTypes.indexOf(label);
  return index >= 0 ? fabricTypeValues[index] : label;
};

// Dyeing Types - Veritabanı değerleri
export const dyeingTypeValues = [
  "yarn_dyed",
  "piece_dyed",
  "printed"
];

// Dyeing Types - Arayüz etiketleri
export const dyeingTypes = [
  "İplik Boyalı",
  "Parça Boyalı",
  "boyalı",
  "Baskılı",
  "Dijital Baskılı",
  "Sublimasyon Baskılı",
  "Transfer Baskılı",
  "Sıcak Transfer Baskılı",
  "Soğuk Transfer Baskılı"
];

export const dyeingTypeValueToLabel = (value: string): string => {
  const index = dyeingTypeValues.indexOf(value);
  return index >= 0 ? dyeingTypes[index] : value;
};

export const dyeingTypeLabelToValue = (label: string): string => {
  const index = dyeingTypes.indexOf(label);
  return index >= 0 ? dyeingTypeValues[index] : label;
};

// Döviz seçenekleri
export const currencyValues = [
  "TRY",
  "USD", 
  "EUR"
];

export const currencies = [
  "₺ TRY",
  "$ USD",
  "€ EUR"
];

export const currencyValueToLabel = (value: string): string => {
  const index = currencyValues.indexOf(value);
  return index >= 0 ? currencies[index] : value;
};

export const currencyLabelToValue = (label: string): string => {
  const index = currencies.indexOf(label);
  return index >= 0 ? currencyValues[index] : label;
};

// Fiyat birimi seçenekleri
export const priceUnitValues = [
  "meter",
  "gram"
];

export const priceUnits = [
  "Metraj (m)",
  "Gramaj (gr/m²)"
];

export const priceUnitValueToLabel = (value: string): string => {
  const index = priceUnitValues.indexOf(value);
  return index >= 0 ? priceUnits[index] : value;
};

export const priceUnitLabelToValue = (label: string): string => {
  const index = priceUnits.indexOf(label);
  return index >= 0 ? priceUnitValues[index] : label;
};
